import { computed, ComputedRef } from 'vue'
import { useRoute, RouteLocationNormalizedLoaded } from 'vue-router'
import { useGoogleAnalytics } from '@/shared/composables/useGoogleAnalytics/useGoogleAnalytics'
import { analyticsPageMapping } from '@/shared/constants/other.constants'
import { PurchaseFlowRoutes } from '@/shared/types/router.types'

interface UseVisitorAnalyticsOptions {
  isEdit: boolean
  isHolder: boolean
}

export const useVisitorAnalytics = (options: UseVisitorAnalyticsOptions) => {
  const route: RouteLocationNormalizedLoaded = useRoute()
  const gaService = useGoogleAnalytics()

  const isHolderInfoPage: ComputedRef<boolean> = computed(
    () => route.name === PurchaseFlowRoutes.HOLDER_INFO
  )

  const analyticsPages: ComputedRef<string> = computed(() => {
    if (isHolderInfoPage.value) {
      return analyticsPageMapping['holder-info']
    }
    return options.isEdit
      ? analyticsPageMapping['edit-visitor']
      : analyticsPageMapping['add-visitor']
  })

  const trackPrivacyPolicy = (): void => {
    let page: string
    if (options.isEdit) {
      page = options.isHolder ? 'update_holder' : 'update_traveller'
    } else {
      page = options.isHolder ? 'add_holder' : 'add_traveller'
    }
    gaService.sendClickPrivacyPolicy(page)
  }

  const handleSelectedDomain = (domain: string): void => {
    gaService.sendEmailAutoFill(domain, analyticsPages.value)
  }

  const sendCloseOcrModal = (
    isClickBtn: boolean,
    isChangeNationality: boolean,
    btnTitle?: string
  ): void => {
    gaService.sendCloseOcrModal(
      isClickBtn ? 'click_btn' : 'close_popup',
      analyticsPages.value,
      isChangeNationality ? 'change_nationality' : 'want_to_remove_file',
      btnTitle
    )
  }

  const sendClickUploader = (
    action: 'click_upload_doc' | 'click_icon',
    subAction?: string
  ): void => {
    gaService.sendClickUploader(action, analyticsPages.value, subAction)
  }

  const sendViewOcrBlock = (): void => {
    gaService.sendViewOcrBlock(analyticsPages.value)
  }

  return {
    isHolderInfoPage,
    trackPrivacyPolicy,
    handleSelectedDomain,
    sendCloseOcrModal,
    sendClickUploader,
    sendViewOcrBlock,
  }
}
